import React from 'react';
import { Container } from './styles';
import { CloseIcon } from '../svg/CloseIcon';
import { useFilterClassification } from '@/hooks/useClassification';

export const FilterIndicator: React.FC = () => {
  const { handleClearAllSearchInputs } = useFilterClassification();
  return (
    <Container>
      <div className='col-1'>
        <CloseIcon />
        <p className='resizeable-accessibility'>Filtros</p>
      </div>
      <div className='col-2' onClick={handleClearAllSearchInputs}>
        <p className='resizeable-accessibility'>Limpar tudo</p>
      </div>
    </Container>
  );
};